module.exports = __webpack_public_path__ + "static/img/OfficialAccount.da367e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/OfficialAccount.jpg
// module id = QmaW
// module chunks = 9